import { BaseComponent } from '@eastsideco/salvo-ts';

export abstract class ThemeComponent extends BaseComponent {
}
